import { SET_SENDERIDS, SET_SCHEDULES } from '../_types';

const initialState = {
    senderIds: [], schedules: []
};

const smsReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;

        case SET_SENDERIDS:
            return {
                ...state,
                senderIds: action.data
            };
        case SET_SCHEDULES:
            return {
                ...state,
                schedules: action.data
            }
    }
};


export default smsReducer;